import React from "react";
import { useLocation } from "react-router-dom";

/**
 * Landing — public marketing home for moovbytes.com.
 *
 * This is the actual purchased "SaaS Product Showcase" page from the
 * themeforest-Z5gPKssQ-aior template (Bootstrap + jQuery), not a React/
 * Tailwind port of it — served statically from /public/landing-template
 * and embedded here in an iframe so its own CSS/JS stack stays fully
 * isolated from the app's React/Tailwind styling and never collides with
 * it. All in-page nav/CTA links inside that template use target="_top",
 * so clicking them navigates this whole document (out of the iframe) to
 * the real app route rather than trying to load it inside the frame.
 *
 * The static page is named landing.html, not index.html: in production
 * the frontend is served by `serve -s build` (SPA fallback), which has
 * a known quirk where any request resolving to a file literally named
 * index.html -- even a legitimate nested one -- gets swallowed by the
 * fallback rewrite and served the app's own root shell instead. Every
 * other file in that folder (css/js/images) is unaffected; renaming
 * just this one file sidesteps it.
 *
 * The template's own copy (all AI-agency placeholder text, fake
 * testimonials, fake customer counts, and fake pricing tiers) has been
 * replaced with MoovBytes' real content directly in
 * public/landing-template/landing.html.
 *
 * The other marketing pages (Capabilities, Documentation, About, Use
 * Cases, How It Works, Support) don't have their own standalone
 * sections anymore — their nav/footer links (see Chrome.jsx) point back
 * at the matching section on this one-pager as "/#features-sec" etc.
 * That hash lives on the PARENT document's URL, which the iframe can't
 * see on its own, so it has to be forwarded into the iframe's own src
 * for the static page's native anchor scrolling to pick it up.
 */
export default function Landing() {
    const { hash } = useLocation();
    return (
        <iframe
            title="MoovBytes"
            src={`/landing-template/landing.html${hash}`}
            data-testid="landing-page"
            style={{
                display: "block",
                width: "100%",
                height: "100vh",
                border: "none",
                background: "#050e22",
            }}
        />
    );
}
